import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { V3School } from '../../../model/v3/schools';
import { SchoolV3Api } from '../casa-native-api';

@Injectable({
  providedIn: 'root',
})
export class SchoolV3RestService implements SchoolV3Api {
  constructor(private http: HttpClient) {}

  private schoolUrl(schoolId: number, path: string = ''): string {
    return `${environment.eventsApiBase}/v1/schools/${schoolId}${path}`;
  }

  getSchool(schoolId: number): Observable<V3School> {
    return this.http.get<V3School>(this.schoolUrl(schoolId));
  }
}
